const type = 'RESET_TIMELINE_ITEMS';

const resetTimelineItems = () => ({
  type,
});

export { type };
export default resetTimelineItems;
